import { Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import * as io from 'socket.io-client';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { API_PATH } from 'src/environments/environment';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass'],
})
export class LoadingComponent implements OnInit {
  @Input('show') show: boolean = false;
  color: ThemePalette = 'primary';
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() value = 0;
  @Input() text = '';

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit(): void {

  }

  public getValue() {
    if (this.value === 0) return '';
    return this.value == 100 ? 'Aguarde...' : `${this.value}%`;
  }
}
